import React, { useState } from 'react';
import propTypes, { func, shape } from 'prop-types';
import { View, Text } from 'react-native';
import { ActivityIndicator, Button, Hr, InfoBox } from 'LocalGluons';
import { t } from 'Locale';
import { useStore } from 'Store/Store';
import defaultStyles from '../PageStyles.jss';

export const RESET_TYPE = Object.freeze({
    PIN: 'PIN',
    PASSWORD: 'PASSWORD'
});

/**
 * @typedef {{ onSendAgain(): void }} Props
 */

/**
 * @param {Props} props
 */
const GetHelp = ({ onSendAgain, data, type }) => {
    const { appManager } = useStore();
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const resetPassword = async () => {
        setLoading(true);
        try {
            const { loginOrNickname } = data;
            await appManager.api.resetPassword({ loginOrNickname });
            onSendAgain({ loginOrNickname });
        } catch (err) {
            setErrorMessage(err.localizedMessage);
        } finally {
            setLoading(false);
        }
    };

    const onSendAgainPressed = () => {
        if (type === RESET_TYPE.PASSWORD) {
            resetPassword();
            return;
        }

        onSendAgain();
    };

    return (
        <>
            <View style={defaultStyles.container}>
                <Text style={defaultStyles.title}>{t('COMMON.GET_HELP')}</Text>
                <Hr />
                <Text style={defaultStyles.description}>{t('VERIFY_CODE.GET_HELP_MSG')}</Text>
                {!!errorMessage && <InfoBox style={defaultStyles.infoBox} message={errorMessage} />}
                <View style={defaultStyles.buttonWidth}>
                    <Button
                        style={defaultStyles.button}
                        title={t('VERIFY_CODE.SEND_AGAIN')}
                        onPress={onSendAgainPressed}
                    />
                </View>
            </View>
            {loading && <ActivityIndicator isOverlay />}
        </>
    );
};

GetHelp.propTypes = {
    onSendAgain: func.isRequired,
    data: shape({}).isRequired,
    type: propTypes.string.isRequired
};

export default GetHelp;
